import { createSelector } from 'reselect';

const selectEsbAuditLog = (state: any) => state.esbAuditLog;


export const selectEsbAuditLogCurrentItem = createSelector([selectEsbAuditLog], (esbAuditLog) => esbAuditLog.current);

export const selectEsbAuditLogListItems = createSelector([selectEsbAuditLog], (esbAuditLog) => esbAuditLog.list);

export const selectEsbAuditLogItemById = (itemId: any) =>
    createSelector(selectEsbAuditLogListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectEsbAuditLogQueryItems = createSelector([selectEsbAuditLog], (esbAuditLog) => esbAuditLog.query);

export const selectEsbAuditLogCreatedItem = createSelector([selectEsbAuditLog], (esbAuditLog) => esbAuditLog.create);

export const selectEsbAuditLogUpdatedItem = createSelector([selectEsbAuditLog], (esbAuditLog) => esbAuditLog.update);

export const selectEsbAuditLogReadItem = createSelector([selectEsbAuditLog], (esbAuditLog) => esbAuditLog.read);

export const selectEsbAuditLogDeletedItem = createSelector([selectEsbAuditLog], (esbAuditLog) => esbAuditLog.delete);

export const selectEsbAuditLogSearchedItems = createSelector([selectEsbAuditLog], (esbAuditLog) => esbAuditLog.search);

export const selectEsbAuditLogItemsCount = createSelector([selectEsbAuditLog], (esbAuditLog) => esbAuditLog.count);

export const selectEsbAuditLogItemsFilter = createSelector([selectEsbAuditLog], (esbAuditLog) => esbAuditLog.filter);